// src/Routes/AuthProtected.tsx

import { Suspense, useEffect, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
// import Loader from "../Common/Loader";

interface ProtectedRouteProps {
  children: ReactNode;
}

const AuthProtected = (props: ProtectedRouteProps) => {
  const { children } = props;
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      // Clear all local storage data
      localStorage.clear();
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  /*
    Navigate is un-auth access protected routes via url
  */
  const token = localStorage.getItem('token');
  if (!token) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          {/* <Loader /> */}
        </div>
      }
    >
      {children}
    </Suspense>
  );
};

export default AuthProtected;